<div class="gw-card">

  <!-- Header: title + how-generated subtitle + Initialize form. -->
  <div class="gw-bar-top">
    <div class="gw-head">
      <span class="gw-title">{{ title }}</span>
      <span class="gw-sub" [ngSwitch]="subtitle?.kind">
        <ng-container *ngSwitchCase="'theme'">
          <span class="gw-l1">Generated from Codigrate Themes</span>
          <span class="gw-l2">Source: <img class="gw-thumb gw-thumb-circle" [src]="subtitle?.logo" alt="" aria-hidden="true"/> <a *ngIf="subtitle?.themeHref" class="gw-em gw-link" [href]="subtitle?.themeHref" target="_blank" rel="noopener">{{ subtitle?.themeName }}</a><span *ngIf="!subtitle?.themeHref" class="gw-em">{{ subtitle?.themeName }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'image'">
          <span class="gw-l1">Generated from an uploaded image</span>
          <span class="gw-l2">Source: <img class="gw-thumb" [src]="subtitle?.imageSrc" alt="" aria-hidden="true"/> <span class="gw-em">{{ imageNameDisplay }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'harmony'">
          <span class="gw-l1">Generated {{ schemeArticle }} {{ subtitle?.scheme }} palette</span>
          <span class="gw-l2">Source: <span class="gw-dot" [style.background-color]="subtitle?.color"></span><a *ngIf="subtitle?.colorHref" class="gw-em gw-link" [href]="subtitle?.colorHref" target="_blank" rel="noopener">{{ subtitle?.name }}</a><span *ngIf="!subtitle?.colorHref" class="gw-em">{{ subtitle?.name }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'full'">
          <span class="gw-l1">Generated a random palette</span>
          <span class="gw-l2">Source: <span class="gw-em">{{ subtitle?.seed ? 'seed-' + subtitle?.seed : 'Random' }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'custom'">
          <span class="gw-l1">Custom Theme</span>
          <span class="gw-l2">Source: <span class="gw-em">{{ subtitle?.seed ? 'seed-' + subtitle?.seed : 'Custom' }}</span></span>
        </ng-container>
        <ng-container *ngSwitchCase="'named'">
          <span class="gw-l1">Generated a featured palette</span>
          <span class="gw-l2">Source: <span class="gw-dot" [style.background]="subtitle?.gradient"></span><span class="gw-em">{{ subtitle?.name }}</span></span>
        </ng-container>
      </span>
    </div>
    <div class="gw-actions">
      <span class="gw-init-label">Quick Start</span>
      <div class="gw-init-row">
        <!-- the shared visual generator picker (owner 2026-10-12), with the curated Featured gradients -->
        <app-generator-picker class="gw-gen" [featured]="true"
                              [scheme]="selectedScheme" [themeKey]="selectedTheme"
                              (schemeChange)="onSchemeChange( $event )" (themeChange)="selectedTheme = $event"></app-generator-picker>
        <div class="gw-rest">
        <div class="gw-init-field gw-init-field-range">
          <label class="gw-init-flabel" [attr.for]="fileInputId + '-range'">
            Range <span class="gw-init-hint">{{ countDisabled ? '(' + lockedCount + ')' : '(' + countMin + '-10)' }}</span>
          </label>
          <span class="gw-init-count-wrap">
            <input [id]="fileInputId + '-range'" type="text" class="gw-init-count"
                   inputmode="numeric" maxlength="2"
                   [value]="count" [disabled]="countDisabled"
                   [title]="countDisabled ? countLockReason : 'Between ' + countMin + ' and 10'"
                   (input)="onCountInput( $any( $event.target ) )"
                   (blur)="onCountCommit( $any( $event.target ) )"
                   [attr.aria-label]="'Number of colors, between ' + countMin + ' and 10'"/>
            <span class="gw-init-stepper">
              <button type="button" class="gw-init-step" tabindex="-1" aria-label="Increase"
                      [disabled]="countDisabled || count >= 10"
                      (pointerdown)="startStep( 1 )" (pointerup)="stopStep()"
                      (pointerleave)="stopStep()" (pointercancel)="stopStep()">
                <svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 5 4.5 1.5a0.7 0.7 0 0 1 1 0L9 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <button type="button" class="gw-init-step" tabindex="-1" aria-label="Decrease"
                      [disabled]="countDisabled || count <= countMin"
                      (pointerdown)="startStep( -1 )" (pointerup)="stopStep()"
                      (pointerleave)="stopStep()" (pointercancel)="stopStep()">
                <svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1 4.5 4.5a0.7 0.7 0 0 0 1 0L9 1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </span>
          </span>
        </div>
        <button type="button" class="gw-init-generate"
                [disabled]="!canGenerate" (click)="onGenerateClick()">
          <app-icon class="gw-init-generate-icon" [name]="selectedScheme === 'image' ? 'upload' : 'rotate'" aria-hidden="true"></app-icon>
          {{ selectedScheme === 'image' ? 'Upload' : 'Generate' }}
        </button>
        </div>
      </div>
      <input [id]="fileInputId" class="gw-file" type="file" (change)="uploadImage.emit( $event )" accept="image/*"/>
    </div>
  </div>

  <!-- Body: the stop bar (74px square chips on a thin gradient track) + the
       selected-stop / global control grid. Fills the card height. -->
  <div class="gw-body">

    <div class="gw-barwrap">
      <div class="gw-bar" #bar [style.background]="barGradient()"
           [class.gw-bar-full]="palette.length >= 10"
           (click)="onBarClick( $event, bar )" role="group" aria-label="Gradient stops">
        <button type="button"
                *ngFor="let c of palette; index as i"
                class="gw-stop"
                [class.active]="activeStop === i"
                [style.left.%]="stopLeft( i )"
                (pointerdown)="startStopDrag( $event, i, bar )"
                (pointermove)="onStopDragMove( $event )"
                (pointerup)="onStopDragEnd()"
                (pointercancel)="onStopDragEnd()"
                (dblclick)="removeStop( i )"
                [attr.aria-label]="'Stop ' + ( i + 1 )">
          <span class="gw-stop-dot" [style.background]="c.value"></span>
        </button>
      </div>
    </div>

    <div class="gw-panel">
      <div class="gw-field gw-field-color">
        <span class="gw-flabel">Color</span>
        <div class="gw-control">
          <label class="gw-inputwrap">
            <input #hx type="text" class="gw-input"
                   [value]="selectedHexLabel"
                   (input)="onHexInput( $any( $event.target ) )"
                   (keydown.enter)="hx.blur()"
                   (blur)="commitHex( hx.value ); hx.value = selectedHexLabel"
                   maxlength="7" spellcheck="false" autocomplete="off" autocapitalize="off"
                   aria-label="Selected stop color"/>
            <span class="gw-swatch" [style.background]="selectedColor">
              <input type="color" class="gw-swatch-pick" [value]="selectedColor"
                     (input)="editColor.emit( { index: idx, value: $any( $event.target ).value } )"
                     aria-label="Pick color"/>
            </span>
          </label>
          <button type="button" class="gw-remove" (click)="removeSelected()"
                  [disabled]="palette.length <= 2" aria-label="Remove stop">
            <app-icon name="trash" aria-hidden="true"></app-icon>
          </button>
          <button type="button" class="gw-remove gw-reverse" (click)="reverseStops()"
                  [disabled]="palette.length < 2" aria-label="Reverse the stops" title="Reverse the stops">
            <app-icon name="right-left" aria-hidden="true"></app-icon>
          </button>
        </div>
      </div>

      <div class="gw-field gw-f-pos">
        <span class="gw-flabel">Position</span>
        <div class="gw-control">
          <label class="gw-inputwrap">
            <input #ps type="text" class="gw-input"
                   [value]="selectedPos + '%'"
                   (keydown.enter)="ps.blur()"
                   (blur)="commitPos( ps.value ); ps.value = selectedPos + '%'"
                   inputmode="numeric" aria-label="Selected stop position"/>
          </label>
        </div>
      </div>

      <div class="gw-field gw-f-type">
        <span class="gw-flabel">Type</span>
        <div class="gw-control">
          <app-cg-select class="gw-type-select" [options]="typeOptions" [value]="type"
                         (valueChange)="typeChange.emit( $any( $event ) )" ariaLabel="Gradient type"></app-cg-select>
        </div>
      </div>

      <div class="gw-field gw-f-rot">
        <span class="gw-flabel">Rotation</span>
        <div class="gw-control" [class.gw-control-off]="!usesAngle">
          <label class="gw-inputwrap">
            <input #rt type="text" class="gw-input"
                   [value]="( usesAngle ? angle : 0 ) + '°'" [disabled]="!usesAngle"
                   (input)="onRotationInput( $any( $event.target ) )"
                   (keydown.enter)="rt.blur()"
                   (blur)="commitRotation( rt.value ); rt.value = ( usesAngle ? angle : 0 ) + '°'"
                   inputmode="numeric" maxlength="3" aria-label="Gradient rotation"/>
          </label>
        </div>
      </div>
      <!-- the gradient itself, its type and angle, the last third and both rows (as the wallpaper tool's
           preview) -->
      <button type="button" class="gw-mini" [style.background]="previewGradient()" (click)="zoomed = true" aria-label="Open the gradient preview large">
        <span class="gw-mini-badge">Preview</span>
      </button>
    </div>

  </div>
</div>

<!-- the preview large, over the page (owner 2026-10-12); a click or Escape closes it -->
<div class="tool-zoom" appToBody *ngIf="zoomed" role="dialog" aria-label="Gradient preview" (click)="zoomed = false">
  <span class="tool-zoom-pic" [style.background]="previewGradient()"></span>
  <button type="button" class="tool-zoom-close" aria-label="Close the preview"><app-icon name="times" aria-hidden="true"></app-icon></button>
</div>

<!-- Home page: a read-more style CTA to the full gradient tool. -->
<div *ngIf="showDetailsCta" class="gw-cta-row">
  <a class="codigrate-button" [routerLink]="detailsRoute" [queryParams]="detailsQueryParams">
    <app-arrow-right [height]="16"></app-arrow-right>
    <p>Open Full Gradient Tool</p>
  </a>
</div>
